"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_PlanDefinition_RelatedAction = exports.PlanDefinition_RelatedActionRelationshipKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Duration_1 = require("./RTTI_Duration");
var RTTI_Range_1 = require("./RTTI_Range");
var PlanDefinition_RelatedActionRelationshipKind;
(function (PlanDefinition_RelatedActionRelationshipKind) {
    PlanDefinition_RelatedActionRelationshipKind["_beforeStart"] = "before-start";
    PlanDefinition_RelatedActionRelationshipKind["_before"] = "before";
    PlanDefinition_RelatedActionRelationshipKind["_beforeEnd"] = "before-end";
    PlanDefinition_RelatedActionRelationshipKind["_concurrentWithStart"] = "concurrent-with-start";
    PlanDefinition_RelatedActionRelationshipKind["_concurrent"] = "concurrent";
    PlanDefinition_RelatedActionRelationshipKind["_concurrentWithEnd"] = "concurrent-with-end";
    PlanDefinition_RelatedActionRelationshipKind["_afterStart"] = "after-start";
    PlanDefinition_RelatedActionRelationshipKind["_after"] = "after";
    PlanDefinition_RelatedActionRelationshipKind["_afterEnd"] = "after-end";
})(PlanDefinition_RelatedActionRelationshipKind = exports.PlanDefinition_RelatedActionRelationshipKind || (exports.PlanDefinition_RelatedActionRelationshipKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_PlanDefinition_RelatedAction = t.recursion('IPlanDefinition_RelatedAction', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        actionId: RTTI_id_1.RTTI_id,
        _actionId: RTTI_Element_1.RTTI_Element,
        relationship: (0, EnumType_1.createEnumType)(PlanDefinition_RelatedActionRelationshipKind, 'PlanDefinition_RelatedActionRelationshipKind'),
        _relationship: RTTI_Element_1.RTTI_Element,
        offsetDuration: RTTI_Duration_1.RTTI_Duration,
        offsetRange: RTTI_Range_1.RTTI_Range
    });
});
//# sourceMappingURL=RTTI_PlanDefinition_RelatedAction.js.map